import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { storeToolkit } from './app/store';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, chooseTheme } from './styles/GlobalStyles';
import { StyledToastContainer } from './components/Toasts/ToastsStyled';

const clientId =
  '917605155022-hv1cel1h6p4f9f499t1ithuho364eum3.apps.googleusercontent.com';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <GoogleOAuthProvider clientId={clientId}>
      <Provider store={storeToolkit}>
        <ThemeProvider theme={chooseTheme}>
          <GlobalStyles />
          <StyledToastContainer />
          <App />
        </ThemeProvider>
      </Provider>
    </GoogleOAuthProvider>
  </>
);
